import { render, staticRenderFns } from "./WidgetButton.vue?vue&type=template&id=d5c8ffa0&"
import script from "./WidgetButton.vue?vue&type=script&lang=js&"
export * from "./WidgetButton.vue?vue&type=script&lang=js&"
import style0 from "./WidgetButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports